import './VenuesForm.css'
import { useTranslation } from 'react-i18next'
import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAddVenueMutation, useUpdateVenueMutation } from '../../redux/venuesService/venuesApiSlice'
import { Header } from '../../components/Header/Header'
import { Input } from '../../components/Input/Input'
import { Button } from '../../components/Button/Button'
import { BottomMenu } from '../../components/BottomMenu/BottomMenu'

const VenusForm = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const updatedVenue = JSON.parse(sessionStorage.getItem('updatedVenue'))
	const communityUid = localStorage.getItem('communityUid')
	const [addVenue] = useAddVenueMutation()
	const [updateVenue] = useUpdateVenueMutation()

	const [name, setName] = useState(updatedVenue?.name ? updatedVenue?.name : '')
	const [address, setAddress] = useState(updatedVenue?.address_string ? updatedVenue?.address_string : '')
	const [surface, setSurface] = useState(updatedVenue?.surface ? updatedVenue?.surface : 'other')
	const [type, setType] = useState(updatedVenue?.indoor_type ? updatedVenue?.indoor_type : 'indoor')
	const [nameErr, setNameErr] = useState(false)
	const [addressErr, setAddressErr] = useState(false)

	const handleNameOnChange = useCallback((value) => {
		setName(value)
	}, [])

	const handleAddressOnChange = useCallback((value) => {
		setAddress(value)
	}, [])

	const handleOnClickInput = useCallback(() => {
		setNameErr(false)
		setAddressErr(false)
	}, [])

	const checkFields = () => {
		let fullFields = true
		const regex = /^(\s*)$/

		if (!address || regex.test(address)) {
			setAddressErr(true)
			fullFields = false
		}

		if (!name || regex.test(name)) {
			setNameErr(true)
			fullFields = false
		}
		return fullFields
	}

	const handleSubmit = async (e) => {
		e.preventDefault()

		if (!checkFields()) {
			return
		}

		try {
			const body = {
				'uid': updatedVenue?.uid ? updatedVenue?.uid : '',
				'name': name,
				'address_string': address,
				'indoor_type': type,
				'surface': surface,
				'community_uids': [communityUid]
			}

			let response

			if (updatedVenue) {
				response = await updateVenue({ body, venue_uid: updatedVenue?.uid }).unwrap()
			} else {
				response = await addVenue({ body }).unwrap()
			}

			if (response?.error) {
				return
			} else {
				navigate('/account/venues')
			}
		} catch (e) {
			console.log('Venues creation and updating catch error', e)
		}
	}

	console.log(updatedVenue?.surface)

	return (
		<>
			<Header
				title={updatedVenue ? t('Edition') : t('Add venue')}
				backButton={true}
			/>

			<div className="venue-form__container">
				<form onSubmit={handleSubmit}>
					<div className="venue-form__input">
						<label className="venue-form__input-label">
							{t('Name')} <span style={{ color: 'red' }}>*</span>
						</label>

						<Input
							value={name}
							onChange={(e) => handleNameOnChange(e.target.value)}
							onClick={handleOnClickInput}
							type="text"
							borderColor={nameErr ? '#F20505' : ''}
							required={false}
						/>

						{
							nameErr &&
							<p className="venue-form__error">
								{t('Enter name')}
							</p>
						}
					</div>

					<div className="venue-form__search">
						<label className="venue-form__input-label">
							{t('Address')} <span style={{ color: 'red' }}>*</span>
						</label>

						<div
							className="venue-form__search-field"
						>
							<Input
								value={address}
								onChange={(e) => handleAddressOnChange(e.target.value)}
								onClick={handleOnClickInput}
								type="text"
								borderColor={addressErr ? '#F20505' : ''}
								required={false}
							/>
						</div>

						{
							addressErr &&
							<p className="venue-form__error">
								{t('Enter address')}
							</p>
						}
					</div>

					<div className="venue-form__inputs-radio">
						<p className="inputs-radio__title">
							{t('Surface')}
						</p>

						<div className="inputs-radio__container">
							<input
								id="radio-clay"
								type="radio"
								name="surface"
								value="clay"
								onChange={() => setSurface('clay')}
								className="inputs-radio__button"
								defaultChecked={updatedVenue?.surface === 'clay' ? true : false}
							/>

							<label htmlFor="radio-clay">
								{t('Clay')}
							</label>
						</div>

						{/* <div className="inputs-radio__container">
							<input
								id="radio-hard"
								type="radio"
								name="surface"
								value="hard"
								onChange={() => setSurface('hard')}
								className="inputs-radio__button"
								defaultChecked={updatedVenue?.surface === 'hard' ? true : false}
							/>

							<label htmlFor="radio-hard">
								{t('Hard')}
							</label>
						</div> */}

						<div className="inputs-radio__container">
							<input
								id="radio-wood"
								type="radio"
								name="surface"
								value="wood"
								onChange={() => setSurface('wood')}
								className="inputs-radio__button"
								defaultChecked={updatedVenue?.surface === 'wood' ? true : false}
							/>

							<label htmlFor="radio-wood">
								{t('Wood')}
							</label>
						</div>

						<div className="inputs-radio__container">
							<input
								id="radio-grass"
								type="radio"
								name="surface"
								value="grass"
								onChange={() => setSurface('grass')}
								className="inputs-radio__button"
								defaultChecked={updatedVenue?.surface === 'grass' ? true : false}
							/>

							<label htmlFor="radio-grass">
								{t('Grass')}
							</label>
						</div>

						<div className="inputs-radio__container">
							<input
								id="radio-other"
								type="radio"
								name="surface"
								value="null"
								defaultChecked={!updatedVenue?.surface ? true : updatedVenue?.surface === 'other' ? true : false}
								onChange={() => setSurface('')}
								className="inputs-radio__button"
							/>

							<label htmlFor="radio-other">
								{t('Other')}
							</label>
						</div>
					</div>

					<div className="venue-form__inputs-radio">
						{/*
						<p className="inputs-radio__title">
							{t("Court type")}
						</p>
						*/}

						<div className="inputs-radio__separator"></div>

						<div className="inputs-radio__container">
							<input
								id="radio-indoor"
								type="radio"
								name="type"
								value="indoor"
								onChange={() => setType('indoor')}
								className="inputs-radio__button"
								defaultChecked={updatedVenue?.indoor_type !== 'outdoor' ? true : false}
							/>

							<label htmlFor="radio-indoor">
								{t('Indoor')}
							</label>
						</div>

						<div className="inputs-radio__container">
							<input
								id="radio-outdoor"
								type="radio"
								name="type"
								value="outdoor"
								onChange={() => setType('outdoor')}
								className="inputs-radio__button"
								defaultChecked={updatedVenue?.indoor_type === 'outdoor' ? true : false}
							/>

							<label htmlFor="radio-outdoor">
								{t('Outdoor')}
							</label>
						</div>
					</div>

					<div className="venue-form__submit">
						<Button type={'submit'} title={t('Save')} />
					</div>
				</form>
			</div>

			<BottomMenu />
		</>
	)
}

export default VenusForm
